import { render, staticRenderFns } from "./VinputGroup.vue?vue&type=template&id=51e56c4e"
import script from "./VinputGroup.vue?vue&type=script&lang=js"
export * from "./VinputGroup.vue?vue&type=script&lang=js"
import style0 from "./VinputGroup.vue?vue&type=style&index=0&id=51e56c4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports